module.exports = {
    "id": "torch",
    "title": "torch",
    "image": "provision/parts/torch/torch.png",
    "info": [
      {
        "text": "Add a torch to your project",
        "image": "provision/parts/torch/torch.png"
      }
    ],
    "exposedVariables": [],
    "codeImage": "provision/parts/torch/torch.png"
  } ;